@if (filteredNotifications.length) {
<li class="h-[350px] overflow-y-auto">
  @for (n of filteredNotifications; track n.id) {

  <div class="border-b border-[#E1E4EA] text-primary dark:border-[#1b2e4b]">
    <div class="group flex items-center gap-3 px-4 py-3 hover:bg-gray-50 dark:bg-[#0e1726]">
      <div class="flex-none">
        <div class="grid h-8 w-8 place-content-center rounded-full border border-[#E1E4EA] bg-[#F5F7FA] text-secondary dark:border-[#1b2e4b] dark:bg-[#1E293B]">
          <ng-container *ngComponentOutlet="n.iconCmp"></ng-container>
        </div>
      </div>
      <div class="flex-1 cursor-pointer" (click)="handleNotificationClick(n)">
        @if ( n.alert_type === 'QUOTATION' || n.alert_type === 'AUCTION' || n.alert_type === 'TENANT_INVITATION' || n.alert_type === 'VENDOR_KYC' ||
        n.alert_type === 'CONTRACT' || n.alert_type === 'GENERAL' || n.alert_type === 'EXPORT' || n.alert_type === 'UPLOAD' ) {
        <div class="flex-1">
          <div class="flex items-start justify-between">
            <h6 class="font-semibold text-[#0E121B] dark:text-white">
              @if (n.alert_type === 'CONTRACT' && n.meta?.contract_id) {
              <span>#{{ n.meta?.contract_id }} {{ formatTitle(n.alert_type) }}</span>
              } @else {
              <span>{{ formatTitle(n.alert_type) }}</span>
              }
            </h6>
            <span class="mt-1 h-2.5 w-2.5 rounded-full" [ngClass]="n.read ? 'bg-success' : 'bg-red-600'"></span>
          </div>

          @if (n?.message) {
          <div class="text-xs text-[#64748B] dark:text-white/60">
            {{ n?.message }}
          </div>
          } @if (n?.title) {
          <div class="text-xs font-medium text-gray-600 dark:text-white/60">
            {{ n?.title }}
          </div>
          } @if (n?.created_at) {
          <div class="text-xs text-[#3c3d3d] dark:text-white/60">
            {{ timeAgo(n?.created_at || '') }}
          </div>
          }
        </div>
        } @else {
        <div class="flex-1">
          <div class="flex items-start justify-between">
            <h6 class="font-semibold text-[#0E121B] dark:text-white">
              <span>{{ formatTitle(n.alert_type) }}</span>
            </h6>
            <span class="mt-1 h-2.5 w-2.5 rounded-full" [ngClass]="n.read ? 'bg-success' : 'bg-red-600'"></span>
          </div>

          @if (n?.message) {
          <div class="text-xs text-[#64748B] dark:text-white/60">
            {{ n?.message }}
          </div>
          } @if (n?.title) {
          <div class="text-xs font-medium text-gray-600 dark:text-white/60">
            {{ n?.title }}
          </div>
          } @if (n?.created_at) {
          <div class="text-xs text-[#3c3d3d] dark:text-white/60">
            {{ timeAgo(n?.created_at || '') }}
          </div>
          }
        </div>
        }
      </div>
    </div>
  </div>
  }
</li>
<li>
  <div class="flex justify-center px-4 py-2">
    <app-button-fill title="Read All Notifications" type="button" (click)="navigateToNotificationList()"> </app-button-fill>
  </div>
</li>
} @if (!filteredNotifications.length) {
<li>
  <div class="!grid max-h-[200px] place-content-center text-lg hover:!bg-transparent">
    <div class="mx-auto mb-4 rounded-full text-primary ring-4 ring-primary/30">
      <svg width="40" height="40" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          opacity="0.5"
          d="M20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10Z"
          fill="currentColor"
        ></path>
        <path
          d="M10 4.25C10.4142 4.25 10.75 4.58579 10.75 5V11C10.75 11.4142 10.4142 11.75 10 11.75C9.58579 11.75 9.25 11.4142 9.25 11V5C9.25 4.58579 9.58579 4.25 10 4.25Z"
          fill="currentColor"
        ></path>
        <path
          d="M10 15C10.5523 15 11 14.5523 11 14C11 13.4477 10.5523 13 10 13C9.44772 13 9 13.4477 9 14C9 14.5523 9.44772 15 10 15Z"
          fill="currentColor"
        ></path>
      </svg>
    </div>
    No notifications available.
  </div>
</li>
}
<app-notification-view-modal
  [open]="viewNotificationModel()"
  [details]="isReadableNotificationDetails()"
  [showGeneral]="true"
  contentClass="max-w-auto modal-content w-full sm:max-w-[500px] lg:max-w-[600px]"
  metaTextClass="text-xs text-primary"
  alertMetaTextClass="text-xs text-secondary"
  footerBorderClass="border-t border-[#E1E4EA] dark:border-[#1b2e4b]"
  (closed)="closeViewNotificationModal()"
></app-notification-view-modal>
